import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import { managementFinanceAPI } from "../../../../api/managementFinanceAPI";
import Productivity from '../../../../assets/images/Productivity.png';
import ProductivityChart from '../../../chart/managementFinanceChart/ProductivityChart/ProductivityChart';
import Calendar from "../../../datepicker/calendar";
import AllPcode from "../../../allPcode";
import usePcode from "../../../../common/hooks/usePcode";

export default function ProductivityModal() {

    const [monthYr, setMonthYr] = useState(new Date());
    const [isFetching, setIsFetching] = useState(false);
    const [showChart, setShowChart] = useState(false);
    const [data, setData] = useState([]);
    const { loggedPcode } = usePcode();
    const [selectedPcode, setSelectedPcode] = useState(loggedPcode);

    const handleData = (selectedPcode, monthYr) => {
        if (!monthYr) { toast.warn("Please select month and year"); return; }

        const month = monthYr.getMonth() + 1;
        const year = monthYr.getFullYear();

        setIsFetching(true);

        managementFinanceAPI.getProductivity(month, year, selectedPcode).then((data) => {
            setIsFetching(false);
            setData(filterdata(data.late1, data.late2, data.onTime));
        }).catch((e) => {
            setIsFetching(false);
            toast.warn(e.message);
        }).finally(() => {
            setIsFetching(false);
        })
    }

    const filterdata = (late1, late2, onTime) => {
        const chartData = [["Job Name", "OnTime", "Late"]];
        const routeMap = {};

        // Populate routeMap with onTime data
        onTime.forEach((item) => {
            if (!routeMap[item.name]) {
                routeMap[item.name] = { onTime: item.onTimeDelivered, late: null };
            } else {
                routeMap[item.name].onTime = item.onTimeDelivered;
            }
        });

        // Add late1 data to routeMap
        late1.forEach((item) => {
            if (!routeMap[item.name]) {
                routeMap[item.name] = { onTime: 0, late: item.lateDelivered };
            } else {
                routeMap[item.name].late = (routeMap[item.name].late || null) + item.lateDelivered;
            }
        });

        // Add late2 data to routeMap
        late2.forEach((item) => {
            if (!routeMap[item.name]) {
                routeMap[item.name] = { onTime: 0, late: item.lateDelivered };
            } else {
                routeMap[item.name].late = (routeMap[item.name].late || null) + item.lateDelivered;
            }
        });

        // Convert routeMap to chartData
        Object.keys(routeMap).forEach(name => {
            const { onTime, late } = routeMap[name];
            chartData.push([name, onTime || 0, late || 0]);
        });

        return chartData;
    };

    useEffect(() => {
        handleData(selectedPcode, monthYr);
    }, [selectedPcode, monthYr])

    useEffect(() => {
        const handleShowChart = () => {
            setShowChart(true);
        };

        const modalElement = document.getElementById("Productivity");
        if (modalElement) {
            modalElement.addEventListener("shown.bs.modal", handleShowChart);
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener("shown.bs.modal", handleShowChart);
            }
        };
    }, []);

    const handleDatePicker = (date) => {
        setMonthYr(date);
    }

    return (
        <>
            <a type="button" className='border border-0 rounded rounded-5' data-bs-toggle="modal" data-bs-target="#Productivity">
                <img src={Productivity} class="card-img-top rounded rounded-5" alt="Productivity" />
            </a>
            <div className="modal fade" id="Productivity" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Productivity</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body w-100 h-100 bg-light">
                            <div className="row">
                                <div className="col-0 col-sm-0 col-md-0 col-lg-9 col-xl-9 col-xxl-9">
                                    <div className="input-group input-group-sm">
                                        <AllPcode setSelectedPcode={setSelectedPcode} loggedPcode={loggedPcode} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3">
                                    <div className="input-group input-group-sm">
                                        <Calendar onChange={handleDatePicker} />
                                    </div>
                                </div>
                                <ProductivityChart loading={isFetching} showChart={showChart} data={data} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
}